import {
  CreateReferralDocument,
  CreateReferralMutation,
  CreateReferralMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export type CreateReferralPayload = CreateReferralMutation['atsMutations']['createAtsReferral']

export const useCreateReferral = () => {
  const [CreateReferral, { loading }] = useMutation(CreateReferralDocument, {
    extractorFn: (data: CreateReferralMutation) => data.atsMutations.createAtsReferral,
  })

  return {
    loading,
    createReferral(variables: CreateReferralMutationVariables) {
      return CreateReferral({
        variables,
      })
    },
  }
}
